import React from "react";

import { mdiExitRun } from "@mdi/js";
import Icon from "@mdi/react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { APP_TOOLTIP_ID } from "@/src/constants/tooltip";

import { LOGOUT_REQUEST } from "../../actions/ActionTypes";

import type { JSX } from "react";

import type { AppState } from "../../reducers";

interface LogoutButtonProps {
  isCollapsed?: boolean;
  collapsedSidebarClassNames: (isCollapsed?: boolean) => string;
}

export default function LogoutButton({
  isCollapsed,
  collapsedSidebarClassNames,
}: LogoutButtonProps): JSX.Element {
  const dispatch = useDispatch();
  const token = useSelector((state: AppState) => state.loginReducer?.token);

  const { t } = useTranslation("profile");

  const logoutContainerClassNames = classNames(
    "w-full flex items-center gap-[0.78125rem] py-[0.3125rem] px-[0.625rem] text-muted-foreground transition-transform duration-300 ease-in-out hover:bg-surface-muted cursor-pointer",
    !isCollapsed && "rounded-[0.46875rem]",
  );

  const logoutIconClassNames = classNames(
    "transition-transform duration-300 ease-in-out flex w-[55px] items-center justify-center",
    isCollapsed ? "-translate-x-2" : "translate-x-0",
  );

  const logoutTextClassNames = classNames(
    collapsedSidebarClassNames(isCollapsed),
    isCollapsed && "w-0",
  );

  const handleLogout = (): void => {
    dispatch({ type: LOGOUT_REQUEST, token });
  };

  return (
    <div className="mx-[0.78125rem] my-[0.3125rem]">
      <button
        className={logoutContainerClassNames}
        data-tooltip-content={t("logout")}
        data-tooltip-hidden={!isCollapsed}
        data-tooltip-id={APP_TOOLTIP_ID}
        data-tooltip-place="right"
        onClick={handleLogout}
        type="button"
      >
        <div className={logoutIconClassNames}>
          <Icon path={mdiExitRun} size={1} />
        </div>
        <div className={logoutTextClassNames}>{t("logout")}</div>
      </button>
    </div>
  );
}
